/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileIndesign32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill="#051E25"
                fillRule="nonzero"
                d="M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z"
            />
            <path
                fill={vars.white}
                fillOpacity={0.5}
                fillRule="nonzero"
                d="M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z"
            />
            <path
                fill="#FF57A1"
                d="M19.866 13c.071 0 .09.027.09.072v8.385c0 .251 0 .565.044.906 0 .063-.018.072-.08.108a5.449 5.449 0 01-2.342.529c-1.975 0-3.387-1.229-3.387-3.73-.01-2.144 1.403-3.813 3.664-3.813.188 0 .295 0 .474.018V13.09c0-.063.044-.09.09-.09h1.447zm-7.364 0c.071 0 .107.027.107.108v9.64c0 .09-.018.117-.116.117h-1.377c-.09 0-.116-.044-.116-.116v-9.632c0-.09.045-.117.116-.117h1.386zm5.3 3.83c-1.154 0-1.958.888-1.958 2.367 0 1.686.822 2.368 1.85 2.368.224 0 .456-.027.635-.108V16.92a1.282 1.282 0 00-.528-.09z"
            />
        </g>
    </AccessibleSVG>
);

export default FileIndesign32;
